import { gql } from "@apollo/client";

export const ADD_DRIVER_DOCUMENT = gql`
  mutation addDriverDocument($driverProfileId: ID!, $document: DriverDocumentInput!){
    addDriverDocument(driverProfileId: $driverProfileId, document: $document){
      id
      title
      documentName
      documentType
      expiryDate
      documentKey
      reminderBefore
      createdAt
    }
  }
`;